"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTGFuturesShareProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_quotation_lib_1 = require("trade_quotation_lib");
/**
 * 处理合约马丁的订单分享及跟单
 */
var MTGFuturesShareProcessor;
(function (MTGFuturesShareProcessor) {
    /** 分享卡片信息 */
    function useShareCardInfo({ exchangeOrder, shareData, $st, dateFormatter, tickerMap, useSymbolPrice, $num, }) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const innerOrder = exchangeOrder && TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
        const quote = (_a = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.quote) !== null && _a !== void 0 ? _a : "USDT";
        const base = (_c = (_b = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.portfolio) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.base;
        const symbolInfo = (0, trade_quotation_lib_1.useSymbol)(base, quote);
        const title = (0, react_1.useMemo)(() => {
            var _a;
            if (shareData === null || shareData === void 0 ? void 0 : shareData.customize_name) {
                return shareData.customize_name;
            }
            return $st("fmtg_share_title", { name: (_a = shareData === null || shareData === void 0 ? void 0 : shareData.nick_name) !== null && _a !== void 0 ? _a : "" });
        }, [$st, shareData === null || shareData === void 0 ? void 0 : shareData.customize_name, shareData === null || shareData === void 0 ? void 0 : shareData.nick_name]);
        const subTitle = (0, react_1.useMemo)(() => {
            var _a, _b;
            const leverageText = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage) ? `${innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage}x` : "--";
            const baseDisplay = (_a = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay) !== null && _a !== void 0 ? _a : "";
            const quoteDisplay = (_b = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) !== null && _b !== void 0 ? _b : "";
            const strKeyMap = {
                long: "trade_trend_long",
                short: "trade_trend_short",
                no_trend: "trade_trend_null",
            };
            const trendText = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend) ? $st(strKeyMap[innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend]) : "--";
            return [`${baseDisplay}/${quoteDisplay}`, leverageText, trendText];
        }, [$st, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay]);
        const baseCoin = (_f = (_e = (_d = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.portfolio) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.base) !== null && _f !== void 0 ? _f : "";
        // 当前基准币价格
        const currentBasePrice = (_g = tickerMap.get(`${baseCoin}/${quote}`)) !== null && _g !== void 0 ? _g : "--";
        const openPrice = (_j = (_h = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.portfolio) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.open_price;
        return {
            title: title,
            subTitle: subTitle,
            marketInfo: {
                openBasePrice: {
                    key: "mtg_share_card_items_open_price",
                    label: $st("mtg_share_card_items_open_price"),
                    value: (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.isConditionAndNotTriggered)
                        ? $st("grid_hedge_futures_not_triggered")
                        : openPrice
                            ? `${$num(openPrice, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision })} ${quote}`
                            : "--",
                },
                currentBasePrice: {
                    key: "mtg_share_card_items_current_price",
                    label: $st("mtg_share_card_items_current_price"),
                    value: currentBasePrice ? `${$num(currentBasePrice, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision })} ${quote}` : "--",
                },
            },
            totalRoundCount: {
                label: $st("mtg_share_total_round_count"),
                value: innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.round_count,
            },
            orderCreateTime: {
                label: $st("mtg_share_create_time"),
                timeStamp: exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp,
                value: !(exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp) ? "--" : (_k = dateFormatter === null || dateFormatter === void 0 ? void 0 : dateFormatter.format) === null || _k === void 0 ? void 0 : _k.call(dateFormatter, exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.timestamp, "YYYY/MM/DD HH:mm"),
            },
        };
    }
    MTGFuturesShareProcessor.useShareCardInfo = useShareCardInfo;
})(MTGFuturesShareProcessor || (exports.MTGFuturesShareProcessor = MTGFuturesShareProcessor = {}));
